import { createFileRoute } from '@tanstack/react-router'

import Breadcrumbs from '@/containers/breadcrumbs'

import Content from '@/components/content'
import FormBlock from '@/components/formBlock'
import PageHeader from '@/components/pageHeader'

import { useSetBreadcrumbs } from '@/state/breadcrumbs'
import { useIdentity } from '@/state/identity'

import ProfileInfoCard from './-components/profileInfoCard'
import ChangePassword from './-components/profileInfoCard/changePassword'
import SettingsNavigation from './-components/settingsNavigation'
import UIThemeCard from './-components/uiThemeCard'

export const Route = createFileRoute('/_authed/$client_code/settings/')({
    component: Settings,
})

function Settings() {
    const { client_code } = Route.useParams()
    const { identity } = useIdentity()
    useSetBreadcrumbs([
        {
            to: '/$client_code/settings',
            text: 'Settings',
            params: { client_code },
        },
        'seperator',
        {
            to: '/$client_code/profile',
            text: 'Profile',
            params: { client_code },
        },
    ])

    if (!identity) {
        return null
    }

    return (
        <>
            <Breadcrumbs />
            <Content>
                <PageHeader title="Profile" />
                <SettingsNavigation active="profile" />
                <FormBlock title="Profile information">
                    <ProfileInfoCard />
                </FormBlock>
                <FormBlock title="Change your password">
                    <ChangePassword />
                </FormBlock>
                <FormBlock title="Appearance" subTitle="Customize your interface color scheme">
                    <UIThemeCard />
                </FormBlock>
            </Content>
        </>
    )
}
